module.exports = __webpack_public_path__ + "static/media/Elements2_Chart.2d696be7.png";